import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map.component';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { LeafletMapModule } from './leaflet/leafletMap.module';
import { GoogleMapModule } from './google/googleMap.module';

@NgModule({
    imports: [
        CommonModule,
        NotificationModule,
        LeafletMapModule,
        GoogleMapModule,
    ],
    declarations: [
        MapComponent,
    ],
    exports: [
        MapComponent,
    ],
    providers: [],
})
export class MapModule { }